<template>
  <div
    v-loading="loading"
    class="article-List"
  >
    <div
      v-show="isShowTree"
      class="left-part"
    >
      <div class="tree-div">
        <el-tree
          ref="tree"
          :data="treeData"
          :props="defaultProps"
          :highlight-current="true"
          :default-expand-all="true"
          :expand-on-click-node="false"
          node-key="catalogId"
          @node-click="handleNodeClick"
        />
      </div>
    </div>
    <div
      :class="['right-part', !isShowTree && 'overspread-right-part']"
    >
      <breadcrumb
        :split-line="breadCrumbLine"
      />
      <template v-if="artList.length != 1 || pagination.current != 1">
        <div
          v-for="(item,index) in artList"
          :key="item.catalogId + '-' + pagination.current * (index+1)"
          class="item"
          @click="goDetail(item)"
        >
          <div class="left-date">
            <div class="day">
              {{ item.month }}.{{ item.day }}
            </div>
            <div>{{ item.year }}</div>
          </div>
          <div class="right-content">
            <div class="title">
              {{ item.title }}
            </div>
            <div class="introduction">
              {{ item.content }}
            </div>
            <div class="hits">
              点击量：{{ item.hits }}
            </div>
          </div>
        </div>
        <el-pagination
          v-show="pagination.total > 0"
          background
          :page-sizes="pageSizes"
          :page-size.sync="pagination.size"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.current"
          :total="pagination.total"
          @current-change="getContent"
          @size-change="sizeChange"
        />
      </template>
      <template v-else>
        <articleContent
          :art-content="artList[0]"
        />
        <timeStatistics :content-id="artList[0].contentId" />
      </template>
      <div
        v-show="!loading && artList.length == 0"
        class="no-data"
      />
    </div>
  </div>
</template>

<script>
import api from '../../proxy';
import { pageSizes } from '@/lib/utils';
import breadcrumb from '../components/breadcrumb';
import articleContent from '../components/articleContent';
import timeStatistics from '../components/timeStatistics';
import { findRootNode, openUrl } from '../../../../../lib/utils';
export default {
    name: 'ArticleList',
    components: {
        breadcrumb, articleContent, timeStatistics,
    },
    data () {
        return {
            siteId: '',
            treeData: [],
            currentNode: {},
            defaultProps: {
                children: 'child',
                label: 'name',
            },
            artList: [],
            pagination: {
                total: 0,
                current: 1,
                size: 10,
            },
            pageSizes,
            loading: true,
            breadCrumbLine: true,
        };
    },
    computed: {
        isShowTree () {
            if (this.treeData.length < 1) return false;
            if (this.treeData[0].child.length && this.treeData[0].child.length === 0) return false;
            return true;
        },
        flatTreeList () {
            return this.$store.getters['system/getFlatTreeList'];
        },
    },
    mounted () {
        const query = this.$router.history.current.query;
        try {
            this.siteId = query.siteId || sessionStorage.getItem('urlSiteId') || '';
        } catch (e) { return; };
        const rootNode = findRootNode(this.flatTreeList, query.catalogId);
        api.web3CatalogTree({ siteId: this.siteId, catalogId: rootNode.catalogId }).then(res => {
            if (res.errcode === 0) {
                this.treeData = res.data;
                let defaultValue = (+query.catalogId === +rootNode.catalogId && this.treeData.length) ? this.treeData[0].catalogId : Number(query.catalogId);
                if (+defaultValue === +rootNode.catalogId) {
                    const childNode = this.flatTreeList.find(itm => +itm.pCatalogId === +defaultValue);
                    if (childNode) defaultValue = childNode.catalogId;
                }
                this.$nextTick(() => {
                    this.$refs.tree.setCurrentKey(defaultValue);
                    this.handleNodeClick({ catalogId: defaultValue });
                });
            } else {
                this.$message.error(res.errmsg);
            }
        });
    },
    methods: {
        handleNodeClick (node) {
            this.currentNode = node || this.$refs.tree.getCurrentNode() || {};
            this.getContent(1);
        },
        sizeChange (p) {
            this.pagination.size = p;
            this.getContent(1);
        },
        async getContent (pageNo) {
            this.loading = true;
            const param = {
                siteId: this.siteId,
                catalogId: this.currentNode.catalogId,
                pageNo: pageNo || this.pagination.current,
                pageSize: this.pagination.size,
            };
            const res = await api.contentPageList(param);
            if (res.errcode === 0) {
                if (res.data.list.length !== 1 || pageNo !== 1) {
                    this.artList = res.data.list.map(itm => {
                        const date = new Date(itm.createTime);
                        const year = date.getFullYear();
                        let month = date.getMonth() + 1;
                        let day = date.getDate();
                        month = month < 10 ? '0' + month : month;
                        day = day < 10 ? '0' + day : day;
                        return Object.assign(itm, { year, month, day });
                    });
                    this.pagination.current = res.data.pageNo;
                    this.pagination.total = res.data.totalCount;
                } else {
                    this.pagination.current = 1;
                    this.pagination.total = 0;
                    const res1 = await api.contentDetail({ contentId: res.data.list[0].contentId });
                    if (res1.errcode === 0) {
                        this.artList = [res1.data];
                    } else {
                        this.$message.error(res1.errmsg);
                    }
                }
            } else {
                this.$message.error(res.errmsg);
            }
            this.loading = false;
        },
        goDetail (item) {
            const query = this.$route.query;
            let catalogId;
            let node = this.flatTreeList.find(itm => +itm.catalogId === +item.catalogId);
            let catalogLevel = node.catalogLevel;
            if (catalogLevel < 3) {
                catalogId = item.catalogId;
            } else {
                while (catalogLevel > 0) {
                    node = this.flatTreeList.find(itm => +itm.catalogId === +node.pCatalogId);
                    catalogLevel = node.catalogLevel;
                    if (catalogLevel < 3) {
                        catalogId = node.catalogId;
                        catalogLevel = 0;
                    }
                }
            }
            let param = Object.assign({}, query, {
                contentId: item.contentId,
                currCatalogId: item.catalogId,
                catalogId,
            });
            const routeUrl = this.$router.resolve({
                path: '/webModulePage/articleDetail',
                query: param,
            });
            openUrl(routeUrl.href);
        },
    },
};
</script>
<style>
.el-select-dropdown__item.selected, .el-radio__input.is-checked + .el-radio__label, .el-radio__input.is-checked .el-radio__inner {
    color: #2873E9;
}
</style>
<style scoped lang="scss">
@import "../style.scss";
.article-List {
    width: $pageWidth;
    margin:  0 auto;
    padding: 40px 0;
    min-height: calc(100vh - 200px);
    ::v-deep .el-loading-mask {
        top: 8px;
    }
    .left-part {
        width: 240px;
        box-sizing: border-box;
        position: fixed;
        .tree-div {
            max-height: calc(100vh - 250px);
            overflow-y: auto;
            scrollbar-width: thin;
            z-index: 0;
            &::-webkit-scrollbar {
                width: 6px;
                height: 6px;
            }
            &::-webkit-scrollbar-thumb {
                background: #d8d8d8;
                border-radius: 10px;
            }
            &::-webkit-scrollbar-track-piece {
                background: transparent;
            }

            background-color: #F5F5F7;
            width: 220px;
            padding: 10px;
            box-sizing: border-box;
            border-radius: 4px;
            scrollbar-width: thin;
            ::v-deep .el-tree,.el-tree--highlight-current {
                background-color: #F5F5F7;
                .expanded, .el-tree-node__expand-icon, .el-icon-caret-right {
                    display: none;
                }
                .el-tree-node.is-current>.el-tree-node__content {
                    background-color: #2873E9;
                    .el-tree-node__label {
                        color: #FFFFFF;
                    }
                }
                .el-tree-node__content {
                    height: 40px;
                    border-radius: 4px;
                    .el-tree-node__label {
                        display: inline-block;
                        padding: 0 10px;
                        //max-width: 220px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
            }
        }
    }
    .right-part {
        width: 950px;
        min-height: 450px;
        margin-left: 260px;
        &.overspread-right-part {
            width: $pageWidth;
            margin-left: 0;
        }
        .item {
            display: flex;
            align-items: center;
            width: 100%;
            height: 138px;
            box-sizing: border-box;
            border-bottom: 1px solid #D8D8D8;
            cursor: pointer;
            &:hover {
                .right-content {
                    .title {
                        color: #2873E9;
                    }
                }
            }
            .left-date {
                width: 100px;
                height: 100px;
                background: #F5F5F7;
                border-radius: 4px;
                box-sizing: border-box;
                padding: 20px;
                color: #464C5B;
                font-size: 16px;
                margin-right: 14px;
                .day {
                    font-size: 24px;
                    font-weight: 600;
                    color: #464C5B;
                    margin-bottom: 15px;
                }
            }
            .right-content {
                width: calc(100% - 116px);
                height: 100px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .title {
                    width: 100%;
                    font-size: 16px;
                    font-weight: 600;
                    color: #464C5B;overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    transition: color 0.3s;
                }
                .introduction {
                    width: 100%;
                    color: #657180;
                    font-size: 14px;
                    line-height: 22px;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    overflow: hidden;
                    -webkit-line-clamp: 2;
                    /*! autoprefixer: off */
                    -webkit-box-orient: vertical;
                    /* autoprefixer: on */
                    text-align: justify;
                    word-break: break-all;
                }
                .hits {
                    width: 100%;
                    text-align: right;
                    color: #9EA7B4;
                    font-size: 14px;
                }
            }
        }
        .no-data {
            margin-top: 20px;
            width: 100%;
            height: 400px;
            background: url("../../../../../assets/image/no_data.png") center no-repeat;
        }
        ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
            background-color: #2873E9;
        }
        ::v-deep .el-pagination__sizes .el-input .el-input__inner:hover {
            border-color: #b7b8bb;
        }
        ::v-deep .el-input__inner:focus {
            border-color: #b7b8bb;
        }
        ::v-deep .el-select-dropdown__item.selected, .el-radio__input.is-checked + .el-radio__label, .el-radio__input.is-checked .el-radio__inner {
            color: #2873E9;
        }
        ::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
            color: #2873E9;
        }
        .art-content {
            margin-top: 40px;
        }
    }
}
</style>
